import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstLetter',
    standalone: false
})
export class FirstLetterPipe implements PipeTransform {

  transform(value: string): string {

    // Check if the value is null, undefined, or an empty string
    if (!value) {
      return '';
    }

    return value.split(' ').map(word => word.charAt(0)).join('');
  }

}
